// Ce vede cineva care n-a intrat încă în cont.
//
// La ScalpX aici e peretele de plată. La noi nu se vinde nimic, deci pagina are alt rol:
// spune ce e înăuntru și cum se intră. Screener-ul rămâne deschis fără cont — doar
// partea de comunitate cere unul, fiindcă acolo scrii sub un nume.

import { el } from '../core/util.js';
import { icon } from './icons.js';
import { session } from '../core/session.js';
import { openAuth } from './auth-modal.js';

const PUNCTE = [
  { ico: 'comments', titlu: 'Общий чат', text: 'Живое обсуждение с графиками прямо из скринера.' },
  { ico: 'lightbulb', titlu: 'Торговые идеи', text: 'Вход, цели, стопы. Исход решают участники голосованием, а цену отслеживает сервер.' },
  { ico: 'trophy', titlu: 'Рейтинг и ранги', text: 'От «Новичка» до «Гуру». Растёт за идеи, которые отработали.' },
  { ico: 'user', titlu: 'Профиль', text: 'Ваши идеи, винрейт и прогресс до следующего ранга — видно всем.' },
];

/**
 * Blocul pentru vizitator. `intro` explică secțiunea în care a intrat, ca mesajul să nu
 * fie același peste tot — cineva care a dat clic pe „Chat" vrea să știe ce e în chat.
 */
export function guestGate(intro = '') {
  return el('div', { class: 'guest' }, [
    el('div', { class: 'guest-card' }, [
      el('span', { class: 'guest-mark' }, [
        el('span', { class: 'tabs-home-s', text: 'S' }),
        el('span', { class: 'tabs-home-x', text: 'X' }),
      ]),
      el('h2', { class: 'guest-title', text: 'Сообщество ScalpScreener' }),
      el('p', { class: 'guest-sub', text: intro || 'Скринер работает без аккаунта. Аккаунт нужен, чтобы писать и публиковать — под своим именем.' }),

      el('div', { class: 'guest-points' }, PUNCTE.map((p) => el('div', { class: 'guest-point' }, [
        el('span', { class: 'guest-point-ico' }, [icon(p.ico, 14)]),
        el('div', {}, [
          el('span', { class: 'guest-point-t', text: p.titlu }),
          el('span', { class: 'guest-point-x', text: p.text }),
        ]),
      ]))),

      el('div', { class: 'guest-actions' }, [
        el('button', {
          class: 'btn primary',
          text: session.empty ? 'Создать первый аккаунт' : 'Войти',
          onclick: () => openAuth(),
        }),
        el('button', {
          class: 'btn',
          text: 'Открыть скринер',
          onclick: () => { location.href = '/screener/coins/'; },
        }),
      ]),

      !session.empty
        ? el('p', { class: 'guest-note' }, [
          icon('send', 11),
          el('span', {
            text: session.mailConfigured
              ? 'После регистрации подтвердите адрес по ссылке из письма.'
              : 'Почта на сервере пока не настроена — ссылку для подтверждения выдаст владелец.',
          }),
        ])
        : null,
    ]),
  ]);
}
